<template>
	<div class="d-flex flex-column signup-bar justify-center">
		<div class="d-flex flex-column justify-center align-center text-center py-0 px-5" style="gap: 16px">
			<div class="signup-text">
				Create a <span class="highlight">free</span> trial account or login to add photos, videos or documents.
			</div>
			<div class="subtitle-text">*Accounts must have Editor access to contribute.</div>
			<v-btn rounded="pill" color="primary" class="create-account-btn" @click="goToTrialPage">Create Trial Account</v-btn>
		</div>
	</div>
</template>

<script>
	export default {
		name: "SignUpPrompt",
		props: {
			// LSP-16192: the shared-project context the recipient was viewing. When
			// present, we thread these through the trial signup so the new account
			// lands back on the shared project (via /free-trial → /autologin).
			projectId: {
				type: String,
				default: ""
			},
			shareId: {
				type: String,
				default: ""
			}
		},
		methods: {
			goToTrialPage() {
				const trialPageUrl = window.env?.VITE_FREE_TRIAL_URL;
				if (!trialPageUrl) {
					console.warn("SignUpPage: VITE_FREE_TRIAL_URL is not configured; cannot redirect to trial page.");
					return;
				}

				if (this.projectId && this.shareId) {
					const url = new URL(trialPageUrl);
					url.searchParams.set("projectId", this.projectId);
					url.searchParams.set("shareId", this.shareId);
					window.location.href = url.toString();
					return;
				}

				window.location.href = trialPageUrl;
			}
		}
	};
</script>

<style scoped>
	.subtitle-text {
		font-size: 0.75rem;
		font-weight: 300;
	}

	.signup-bar {
		background-color: white;
		padding: 20px;
		border-top: 1px solid #ddd;
		overflow: hidden;
		align-items: center;
	}

	.signup-text {
		font-size: 18px;
		font-weight: 700;
		color: #333;
		margin: 0;
		text-align: center;
	}

	.highlight {
		color: #007bff;
		font-style: italic;
	}

	@media (min-width: 960px) {
		.signup-bar {
			background-color: transparent !important;
			border: none !important;
		}
	}
</style>
